.modalContent {
  display: flex;
  flex-direction: column;
}


.logoBox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  background: var(--adl-surface-container);
  overflow: hidden;
}

.logoImage {
  width: 40px;
  height: 40px;
  border-radius: 2px;
  object-fit: contain;
}

.logoInitials {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.terminalLabel {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
  color: var(--adl-text-secondary);
  text-transform: uppercase;
}

.terminalCode {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.terminalAddress {
  font-size: var(--mantine-font-size-xs);
  color: var(--adl-text-primary);
}
